

















































































import { Component } from "vue-property-decorator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
@Component({
  name: "game-killer-modal-component",
})
export default class GameKillerModalComponent extends mixins(
  NotificationEvent
) {
  url = require("../../../../assets/images/game/zombieoffice_0.jpg");
  mounted() {}
  get active() {
    const e = this.$store.getters["SystemStore/getGameKillerModal"];
    if (e) this.loadImage();
    return e;
  }
  get space() {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setGameKillerModalAction", e);
  }
  loadImage() {
    const randomNumber = Math.floor(Math.random() * 20);
    this.url = require("../../../../assets/images/game/zombieoffice_" +
      randomNumber +
      ".jpg");
  }
  close() {
    this.active = false;
  }
}
